import AttachFileIcon from '@mui/icons-material/AttachFile';
import { v4 as uuid } from 'uuid';
import { IconButton } from "@mui/material";
import { Component } from "react";
import { getFileData } from '../utils';

export default class AttachmentInput extends Component {

   fileInputId = 'txt-' + uuid();

   onChange = async (e) => {
      const file = e.target.files[0];
      const res = await getFileData(file);

      this.props.onChange({
         name: res.name,
         base64: res.base64,
         ext: res.ext,
      });
      
   }

   openFileDialog = () => {
      const input = document.querySelector(`#${this.fileInputId}`);
      input.click();
   }

   render() {

      return <div>
         <div className='text-xs text-gray-600 mb-1'>
            {this.props.label}
         </div>
         <div className="grid grid-cols-[1fr,auto] border-b-[1px] border-b-gray-400 bg-gray-200 rounded-lg overflow-hidden">
            <div className='px-2 py-2 truncate'>
               <input type="file" onChange={this.onChange} className='hidden h-[0px]' id={this.fileInputId} accept={this.props.accept} />
               {this.props.name ? this.props.name : 'No file selected' }
            </div>
            <IconButton onClick={this.openFileDialog} className='bg-orange-600 text-white rounded-none aspect-square' size='small'>
               <AttachFileIcon />
            </IconButton>
         </div>
      </div>
   }
}